import { FactoryResponse as ResponseApi } from '@/types/_'

export default class IntegradorFinxFactoryResponse {
  public build(request): ResponseApi {
    const responseApi: ResponseApi = { }
    responseApi.success = request.data.Success
    responseApi.data = request.data.Value

    if (request.message) {
      responseApi.message = request.data.Message
    }
    if (request.errors) {
      responseApi.errors = request.data.Errors
    }

    return responseApi
  }
}
